export default {
    items: [],
    selectedItem: null,
    filter: {
        sorted: false,
        grouped: false
    }
}